import DramaCard from '@/components/feature/DramaCard';
import type { Drama } from '@/types/content';

interface RelatedDramasProps {
  current: Drama;
  all: Drama[];
}

export default function RelatedDramas({ current, all }: RelatedDramasProps) {
  const related = all
    .filter((item) => item.id !== current.id)
    .sort((a, b) => {
      const aSame = a.category === current.category ? 1 : 0;
      const bSame = b.category === current.category ? 1 : 0;
      if (aSame !== bSame) return bSame - aSame;
      return b.heat - a.heat;
    })
    .slice(0, 3);

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">相关推荐</h2>
        <p className="mt-3 text-sm text-foreground-600">
          同类题材或同样在追的短剧，也都已整理好更新顺序与分集剧情介绍。
        </p>
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {related.map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}